import React from 'react'
import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import Logout from './../../Shared/Logout/Logout';
import NavItem from './NavItem';
import { FiLogOut } from 'react-icons/fi';
import { BsHeartFill } from 'react-icons/bs';
import { MainWrapperContext } from '.';

export default function SideNav() {

    const { sidebarcomponent, switchcomponent } = React.useContext(MainWrapperContext);
    return (
        <>
            <Box
                boxShadow="0 3px 20px rgb(0 0 0 / 4%)"
                pos="fixed"
                as="nav"
                top="0"
                left="0"
                zIndex="sticky"
                h="full"
                pb="10"
                background="white"
                overflowX="hidden"
                overflowY="auto"
                borderColor={useColorModeValue('inherit', 'gray.700')}
                w={60}
            >
                <Flex px="4" py="5" align="center">
                    <Box
                        fontSize="2xl"
                        ml="2"
                        color={useColorModeValue('brand.500', 'white')}
                        fontFamily="monospace"
                    >
                        <Text display="inline" fontWeight="medium" color="green.500">
                            Job
                        </Text>
                        <Text display="inline" fontWeight="extrabold">
                            WorkPad
                        </Text>
                    </Box>
                </Flex>

                {sidebarcomponent()}

                <NavItem fontWeight="sm" icon={BsHeartFill}>
                    <a
                        href="https://forms.gle/t7tguJr4T629L1np9"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Feedback
                    </a>
                </NavItem>

                <Logout>
                    <NavItem fontWeight="sm" icon={FiLogOut}>
                        LogOut
                    </NavItem>
                </Logout>

                <Box
                    position="absolute"
                    bottom="0"
                    fontWeight="md"
                    fontSize="0.8em"
                    p="2   "
                >
                    Version 1.1.0
                </Box>
            </Box>
        </>
    )
}
